var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "manager-tab",
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.activateModal($event)
        }
      }
    },
    [
      _c("img", {
        staticClass: "manager-tab__thumbnail",
        attrs: { src: _vm.item.headshot }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "manager-tab__identity" }, [
        _c("h5", { staticClass: "identity__position" }, [
          _vm._v(_vm._s(_vm.item.title))
        ]),
        _vm._v(" "),
        _c("h5", { staticClass: "identity__name" }, [
          _vm._v(_vm._s(_vm.item.name))
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "manager-tab__icon" }, [
      _c("i", { staticClass: "fa fa-chevron-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }